<template>
  <div
    class="user-avatar"
    :class="{
      'user-avatar_rounded': rounded,
      'user-avatar_bordered': bordered
    }"
    :style="{ width: size && `${size}px` }"
  >
    <div
      class="user-avatar__img"
      :style="{ backgroundImage: img && `url(${img})` }"
    >
      <svg v-if="!img && !initials && !username" viewBox="0 0 32 33" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M22.2725 25.1325C21.185 24.685 19.84 24.1075 19.84 23.66V20.78C21.44 19.565 22.4 17.645 22.4 15.66V11.82C22.4 8.30001 19.52 5.42001 16 5.42001C12.48 5.42001 9.60001 8.30001 9.60001 11.82V15.66C9.60001 17.645 10.56 19.6275 12.16 20.78V23.66C12.16 24.045 10.815 24.62 9.72751 25.1325C7.10501 26.22 3.20001 27.885 3.20001 32.3V32.94H28.8V32.3C28.8 27.885 24.895 26.22 22.2725 25.1325Z"
        />
      </svg>
    </div>
    <svg
      class="user-avatar__svg"
      viewBox="0 0 40 40"
      width="40"
      height="40"
    >
      <text
        x="50%"
        y="26"
        height="20"
        text-anchor="middle"
      >
        {{ initials }}
      </text>
    </svg>
  </div>
</template>

<script>
export default {
  name: 'Avatar',
  props: {
    username: String,
    size: Number,
    rounded: {
      type: Boolean,
      default: true
    },
    bordered: {
      type: Boolean,
      default: false
    },
    img: String
  },
  computed: {
    initials () {
      if (!this.username) {
        return null
      }
      const name = this.username.trim().split(' ')
      if (name.length < 2) {
        return name[0][0]
      }
      return name[0][0] + name[name.length - 1][0]
    }
  }
}
</script>

<style lang="scss">
  .user-avatar {
    flex: 0 0 auto;
    text-align: center;
    width: 40px;
    max-width: 100%;
    font-size: 18px;
    background-color: $color-primary-2;
    color: $color-primary;
    font-family: Helvetica, Arial, sans-serif;
    font-weight: normal;
    line-height: 1;
    text-transform: uppercase;
    white-space: nowrap;
    text-decoration: none;
    position: relative;
    overflow: hidden;

    &_rounded {
      border-radius: 50%;
    }

    &_bordered {
      border: 4px solid $color-white;
      box-shadow: $elevation-deth-4;
    }

    &::before {
      content: "";
      display: block;
      width: 100%;
      padding-top: 100%;
    }

    &__img,
    &__svg {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
    }

    &__img {
      background-size: cover;
      background-position: center;
      background-repeat: no-repeat;
      z-index: 1;
      color: $color-primary-4;

      svg {
        width: 100%;
        height: 100%;
      }
    }
  }
</style>
